:host {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border: 0;

  .product-link {
    border: 0; // fixes PORTAL integration issue for non-shadow browser [DAC-22624]
    padding-bottom: 12px;
    text-decoration: none !important;
    color: var(--sdx-color-gray);
    font-size: 14px !important;
    line-height: 1.5 !important;
    display: flex;

    &__image {
      margin-right: var(--sdx-baseline);

      img {
        width: 96px;
        height: 96px;
      }
    }

    &__body {
      padding-top: 4px;
      flex-grow: 1;
      justify-content: center;

      .product-price {
        display: block;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
}

:host(:hover) {
  .product-link {
    color: var(--sdx-color-int-blue);
  }
}

:host(.focus) {
  .product-link {
    color: var(--sdx-color-int-blue);
  }
}
